var isObject = require('../lang/isObject');

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject(value) ? value : Object(value);
}

module.exports = toObject;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/internal/toObject.js
 ** module id = 184
 ** module chunks = 0 1
 **/